import { render, staticRenderFns } from "./DaftarRole.vue?vue&type=template&id=f0a88748&scoped=true"
import script from "./DaftarRole.vue?vue&type=script&lang=js"
export * from "./DaftarRole.vue?vue&type=script&lang=js"
import style0 from "./DaftarRole.vue?vue&type=style&index=0&id=f0a88748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a88748",
  null
  
)

export default component.exports